import { initializeApp } from "firebase/app";

import {
    getMessaging,
    getToken,
    onMessage,
    deleteToken
} from "firebase/messaging";


// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCooUalfT4N1rwvYfwcA0Bw870jYQZ85qg",
    authDomain: "secu-doc.firebaseapp.com",
    projectId: "secu-doc",
    storageBucket: "secu-doc.firebasestorage.app",
    messagingSenderId: "534340047897",
    appId: "1:534340047897:web:a3c64bc8ddc1aaf2bfc688"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export {
    getToken,
    onMessage,
    deleteToken
};